import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {MiniPanel} from './EmbededPanel.react';
import urlMapping from '../app/URLMapping';
import EventTracker from '../app/EventTracker';
import { User } from '../../common/types/types';

interface InternalErrorMinifiedProps {
    user: User;
}

class InternalErrorMinified extends React.Component<InternalErrorMinifiedProps> {

    static propTypes = {
        user: PropTypes.object.isRequired,
    };
    static contextTypes = {
        embededPanelController: PropTypes.object,
        router: PropTypes.object,
    };

    constructor(props) {
        super(props);

        EventTracker.initEventTracker(props.user);
    }

    showLargeError = () => {
        let urlObject = this.context.embededPanelController.getURLObject();
        let path = urlMapping.getUrl("panel", "error", urlObject);
        this.context.router.push(path);
    };

    render() {
        return (
            <MiniPanel hideMenu restore={this.showLargeError} typeForTest="internal-error"/>
        );
    }
}

export default Relay.createContainer(InternalErrorMinified, {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        user: () => {
            return Relay.QL`
                fragment on User {
                    id,
                    realId,
                    ${EventTracker.getFragment()}
                }`;
        }
    },


});


